<template>
  <div id="app">
    <router-view name="header"></router-view>
    <main>
      <fade-transition origin="center" mode="out-in" :duration="250">
        <router-view :key="viewKey"/>
      </fade-transition>
    </main>
    <router-view name="footer"></router-view>
    <loading/>
    <error-dialog/>
    <success-dialog
      :show.sync="successShow"
      :title="successTitle"
      :message="successMessage"
      :meta="successMeta"/>
  </div>
</template>
<script>
import {FadeTransition} from "vue2-transitions";
import Loading from "@/layout/Loading.vue";
import ErrorDialog from "@/components/dialogs/ErrorDialog.vue";
import SuccessDialog from "@/components/dialogs/SuccessDialog.vue";

export default {
  components: {
    ErrorDialog,
    SuccessDialog,
    FadeTransition,
    Loading,
  },
  computed: {
    // 商品頁只在 created 載入資料；從一個型錄切到另一個型錄（例如點別的型錄的通知）要重新建立元件
    viewKey() {
      return this.$route.name === 'commodity' ? 'commodity-' + this.$route.params.id : 'view';
    },
    successShow: {
      get() { return this.$store.state.success.is_show_success; },
      set(v) { if (!v) this.$store.dispatch('success/hide'); },
    },
    successMessage() { return this.$store.state.success.message; },
    successMeta() { return this.$store.state.success.meta; },
    successTitle() { return '下單成功'; },
  },

};
</script>
